import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { UserHandlerKey } from "../context/UsersContext";

interface UserConfirmDialogProps {
  handlerKey: UserHandlerKey | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UserConfirmDialog = ({
  handlerKey,
  onConfirm,
  onCancel,
}: UserConfirmDialogProps) => {
  const { t } = useTranslation();

  if (!handlerKey) return null;

  return (
    <AlertDialog open={!!handlerKey} onOpenChange={onCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`users.dialogs.${handlerKey}.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(`users.dialogs.${handlerKey}.description`)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onConfirm}>
            {t(`users.dialogs.${handlerKey}.confirm`)}
          </AlertDialogAction>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
